<section>
  <app-breadcrumb [label]="labelBreadcrumb"></app-breadcrumb>

  <div class="section__main section__main--commissions">
    <div class="section__title section__title--mb">
      <h1>
        Comisiones
      </h1>
    </div>

    <div class="commission__block">
      <div class="commission__summary">
        <div class="commission__circle">
          <div class="commission__info">
            <div class="values">
              <i class="pi pi-money-bill icon-circle-commissions"></i>
              <h2>{{ accumulatedBalance | currency: '' : '': '1.2-2' }}</h2>
              <sup>{{ environment.global.country.currency }}</sup>
            </div>
            <div class="text">
              <p>Mis comisiones acumuladas</p>
            </div>
          </div>
        </div>

        <div class="commission__btn">
          <button pButton pRipple label="Ver comisiones por marca" icon="pi pi-eye" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded n-background min-pad" [routerLink]="['/comisiones/por-marca']"></button>
        </div>
      </div>
    </div>

    <div class="commission__block pt-30">
      <div class="boxCard">
        <div class="boxCard__header">
          <h3>{{title}}</h3>
        </div>
        <div class="boxCard__content bigPad">          
          <div class="commission__sales">
            <div class="commission__salesBlock">
              <div class="commission__salesBlockContent">
                <div class="commission__salesBox">
                  <app-sales-preview [salesDescription]="salesDayDescription" [numberOfSales]="numberSalesDay"></app-sales-preview>
                </div>
                <div class="commission__salesBox">
                  <app-sales-preview [salesDescription]="salesWeekDescription" [numberOfSales]="numberSalesWeek"></app-sales-preview>
                </div>
                <div class="commission__salesBox">
                  <app-sales-preview [salesDescription]="salesMonthDescription" [numberOfSales]="numberSalesMonth"></app-sales-preview>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
